var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect } from 'react';
import { Button, Card, CardContent, Typography } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { useLazyQuery, useMutation } from '@apollo/client';
import mutationVariables from '../../../utility/mutationVariables';
import { ActivateEtlDocument, InactivateEtlDocument, ExecuteEtlDocument, GetJobDocument, GetEtlsByDestinationDocument, } from '../../../generated/graphql';
import AlertDialog from '../AlertDialog';
var useStyles = makeStyles({
    root: {
        flex: 1,
        marginRight: 20,
        minWidth: 286,
        maxHeight: 200,
    },
    withStatus: {
        display: 'flex',
        alignItems: 'center',
    },
});
var EtlCard = function (_a) {
    var etl = _a.etl, variables = _a.variables;
    var theme = useTheme();
    var classes = useStyles();
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var _d = useLazyQuery(GetJobDocument, {
        fetchPolicy: 'network-only',
    }), getJob = _d[0], data = _d[1].data;
    var _e = useMutation(ExecuteEtlDocument), executeEtl = _e[0], executeError = _e[1].error;
    useEffect(function () {
        setTimeout(function () {
            var _a;
            if (data && data.job && !['FINISHED', 'FAILED'].includes(data.job.state)) {
                getJob({ variables: { id: data.job.id } });
            }
            if (['FINISHED', 'FAILED'].includes((_a = data === null || data === void 0 ? void 0 : data.job) === null || _a === void 0 ? void 0 : _a.state)) {
                setDisabled(false);
            }
        }, 1000);
    }, [data]);
    var onClickExecuteEtl = function () {
        executeEtl(mutationVariables({ id: etl.id, variables: variables })).then(function (result) {
            getJob({ variables: { id: result.data.executeEtl.id } });
            setDisabled(true);
        });
    };
    var activate = useMutation(ActivateEtlDocument, {
        update: function (cache, _a) {
            var activateEtl = _a.data.activateEtl;
            var etlsByDestination = __assign({}, cache.readQuery({
                query: GetEtlsByDestinationDocument,
                variables: { destinationId: activateEtl.destination.id },
            })).etlsByDestination;
            cache.writeQuery({
                query: GetEtlsByDestinationDocument,
                variables: { destinationId: activateEtl.destination.id },
                data: {
                    etlsByDestination: __spreadArrays(etlsByDestination.filter(function (etl) { return etl.id !== activateEtl.id; }), [activateEtl]).sort(function (a, b) { return a.id - b.id; }),
                },
            });
        },
    })[0];
    var inactivate = useMutation(InactivateEtlDocument, {
        update: function (cache, _a) {
            var inactivateEtl = _a.data.inactivateEtl;
            var etlsByDestination = __assign({}, cache.readQuery({
                query: GetEtlsByDestinationDocument,
                variables: { destinationId: inactivateEtl.destination.id },
            })).etlsByDestination;
            cache.writeQuery({
                query: GetEtlsByDestinationDocument,
                variables: { destinationId: inactivateEtl.destination.id },
                data: {
                    etlsByDestination: __spreadArrays(etlsByDestination.filter(function (etl) { return etl.id !== inactivateEtl.id; }), [
                        inactivateEtl,
                    ]).sort(function (a, b) { return a.id - b.id; }),
                },
            });
        },
    })[0];
    return (React.createElement(Card, { variant: "outlined", className: classes.root },
        React.createElement(CardContent, null,
            React.createElement(Typography, { className: classes.withStatus },
                React.createElement(Button, { onClick: function () { return setOpen(true); } },
                    React.createElement(FiberManualRecordIcon, { style: etl.state === 'ACTIVE' ? { color: theme.palette.neutral.main } : { color: theme.palette.error.main } }),
                    etl.state),
                React.createElement(AlertDialog, { open: open, setOpen: setOpen, question: "Make this datamart " + (etl.state === 'ACTIVE' ? '"inactive"' : '"active"') + "?", onClickOk: function () {
                        etl.state === 'ACTIVE'
                            ? inactivate(mutationVariables({ id: etl.id }))
                            : activate(mutationVariables({ id: etl.id }));
                    } })),
            React.createElement(Typography, { variant: "body2", component: "p" },
                "Created At: ",
                etl.createdAt),
            React.createElement(Typography, { variant: "body2", component: "p" },
                "Updated At: ",
                etl.updatedAt),
            React.createElement(Typography, { variant: "body2", component: "p" },
                "Executed At: ",
                etl.lastExecutedAt),
            React.createElement(Button, { variant: "outlined", color: "primary", onClick: onClickExecuteEtl, disabled: disabled }, "execute"),
            React.createElement("div", { style: { display: 'inline', margin: 10 } }, {
                INITIAL: null,
                ENQUEUED: 'Enqueued 🏠',
                RUNNING: 'Running 🏃‍♀️',
                FINISHED: 'Finished 🙆‍♀️',
                FAILED: 'Failed 😕',
            }[data ? data.job.state : 'INITIAL'] || null))));
};
export default EtlCard;
